import React, { createContext, ReactNode, useState, useContext } from 'react';

import { PaginationControls } from '../../../../../components/Buttons/PaginationControls';
import { AverageTimeByPeople } from '../../../../indicators/types/Indicators';

type ContextValue = {
  averageTimeChartData: AverageTimeByPeople[];
  areaSelected: number;
  collaboratorsSelctValue: number;
  isLoading: boolean;
  averageValues: Array<AverageTimeByPeople[]>;
  setAverageTimeChartData: (value: AverageTimeByPeople[]) => void;
  setAreaSelected: (area: number) => void;
  setCollaboratorsSelctValue: (collaborator: number) => void;
  setAverageValues: (arrayAvarageValues: Array<AverageTimeByPeople[]>) => void;
  setIsLoading: (value: boolean) => void;
};

const AverageTimeContext = createContext<ContextValue | undefined>(undefined);

type Props = {
  children: ReactNode;
};

export function AverageTimeContextProvider(props: Props) {
  const { children } = props;
  const [areaSelected, setAreaSelected] = useState<number>(0);
  const [collaboratorsSelctValue, setCollaboratorsSelctValue] = useState<number>(0);
  const [averageValues, setAverageValues] = useState<Array<AverageTimeByPeople[]>>([]);
  const [averageTimeChartData, setAverageTimeChartData] = useState<AverageTimeByPeople[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const value = {
    averageTimeChartData,
    areaSelected,
    collaboratorsSelctValue,
    averageValues,
    isLoading,
    setAverageTimeChartData,
    setAreaSelected,
    setCollaboratorsSelctValue,
    setAverageValues,
    setIsLoading,
  };

  return (
    <AverageTimeContext.Provider value={value}>
      {children}
      <PaginationControls
        arrayValues={averageValues}
        setNewValue={setAverageTimeChartData}
        title="Tempo médio por colaborador"
      />
    </AverageTimeContext.Provider>
  );
}

export function useAverageTimeContext() {
  const context = useContext(AverageTimeContext);

  if (typeof context === 'undefined') {
    throw new Error('AverageTimeContext must be used within an AverageTimeContext');
  }

  return context;
}
